<template>
  <div class="overflow-auto">
    <b-table responsive
      class="pt-3 pr-3"
      id="my-table"
      :items="items"
      :fields="fields"
    >
    <template #head()="data">
      {{ $t(data.label) }}
    </template>
      <template #cell(image)="data">
        <img :src="data.item.image" style="max-width: 100px;"/>
      </template>
      <template #cell(status)="data">
        <div v-if="labelEach == 1">
          <div class="caption align-items-center justify-content-end">
            <!-- <span>{{$t(data.field.label)}}</span> -->
            <div v-if="data.value=='Rejected'" class="d-flex align-items-center">
                <popupRejectInfo v-if="data.item.rejected_code" :list="data.item.rejected_code"></popupRejectInfo>
            </div>
            
          </div>
          <div class="status text-right">
            <div :class="'badge-default badge-'+data.value.toLowerCase()">{{ $t(data.value) }}</div>
          </div>
        </div>
        <div v-else class="d-flex align-items-center">
          <span :class="'status text-center bg-'+data.value.replace(' ','-').toLowerCase()">{{$t(data.value)}}</span>
          <!-- REJECT INFO -->
          <div v-if="data.value=='Rejected'" class="d-flex align-items-center">
              <popupRejectInfo :list="data.item.rejected_code"></popupRejectInfo>
          </div>
        </div>
      </template>
      <template #cell(amount)="data">
        <div v-if="labelEach == 1">
          <div class="caption">{{$t(data.field.label)}}</div>
          <div :class="'text-end '+(parseFloat(data.value)<0?'text-danger fw-700':'')" v-html="data.value"></div>
        </div>
        <span v-else v-html="data.value" :class="'text-end '+(parseFloat(data.value)<0?'text-danger fw-700':'')"></span>
      </template>
      <template #cell(action_card_management)="data">
        <div class="d-flex">
          <ActionCardManagement :data="data" @do-cancel="cancelCard" @lock-unlock="lockUnlock"></ActionCardManagement>
        </div>
      </template>
      <template #cell()="data" v-if="labelEach == 1">
        <div class="caption">{{$t(data.field.label)}}</div>
        <div>{{ $t(data.value) }}</div>
      </template>
    </b-table>
  </div>
</template>

<script>
import popupRejectInfo from "@/components/popupRejectInfo";
import ActionCardManagement from "@/components/ActionCardManagement";

  export default {
    data() {
      return {
        publicPath :process.env.BASE_URL!='/'?process.env.BASE_URL:'',
        hoverCancelButton:false,
        hoverLockButton:false
      }
    },
    components:{
        popupRejectInfo,
        ActionCardManagement
    },
    props: ['items','labelEach','fields'],
    methods:{
      cancelCard(card_number){
        this.$emit('do-cancel',card_number);
      },
      lockUnlock(params){
        this.$emit('lock-unlock',params);
      }
    }
  }
</script>